import { FunctionComponent, ReactNode } from "react";
import { cn } from "../../utils/cn";

export interface ModalContentProps {
  className?: string;
  children: ReactNode;
  "data-testid"?: string;
}

/**
 *
 */
export const ModalContent: FunctionComponent<ModalContentProps> = ({
  className,
  children,
  "data-testid": dataTestId,
}) => {
  const css = cn(className, "overflow-y-auto grow shrink p-4");
  const testId = dataTestId || "modal-content-body";
  return (
    <div className={css} data-testid={testId}>
      {children}
    </div>
  );
};
